import { useIntl } from 'react-intl';
import {
    getTransportAssignmentSearchMode,
    getTransportAssignmentSearchTerm,
    setTransportAssignmentSearchTerm,
    TransportAssignmentSearchMode,
    transportAssignmentsSlice,
} from '../../../reducers/transportAssignmentsSlice';
import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { MultiModeSearch, SearchModeOption } from '../../../sharedComponents/table/MultiModeSearch';

export const TransportOrderToolbarSearch = () => {
    const intl = useIntl();
    const searchMode = useAppSelector(getTransportAssignmentSearchMode);
    const searchTerm = useAppSelector(getTransportAssignmentSearchTerm);
    const dispatch = useAppDispatch();

    const selectOptions: SearchModeOption<TransportAssignmentSearchMode>[] = useMemo(
        () =>
            Object.values(TransportAssignmentSearchMode).map((mode) => ({
                id: mode,
                label: intl.formatMessage({
                    id: `outboundOrderBook.transportAssignments.table.toolbar.search.mode.${mode}.label`,
                }),
                placeholder: intl.formatMessage({
                    id: `outboundOrderBook.transportAssignments.table.toolbar.search.mode.${mode}.placeholder`,
                }),
            })),
        [intl],
    );

    const onSearchModeChange = useCallback(
        (mode: TransportAssignmentSearchMode) => dispatch(transportAssignmentsSlice.actions.setSearchMode(mode)),
        [dispatch],
    );

    const onSearchTermChange = useCallback(
        (newValue: string) => dispatch(setTransportAssignmentSearchTerm({ value: newValue })),
        [dispatch],
    );

    const onClear = useCallback(
        () => dispatch(setTransportAssignmentSearchTerm({ value: '', immediate: true })),
        [dispatch],
    );

    const onEnterPressed = useCallback(
        () => dispatch(setTransportAssignmentSearchTerm({ value: searchTerm, immediate: true })),
        [searchTerm, dispatch],
    );

    return (
        <MultiModeSearch
            modes={selectOptions}
            selectedMode={searchMode}
            onSearchModeChange={onSearchModeChange}
            searchTerm={searchTerm}
            onSearchTermChange={onSearchTermChange}
            onClear={onClear}
            onEnterPressed={onEnterPressed}
        />
    );
};
